import type { ReactNode } from "react";
import Sidebar from "./Sidebar";

interface AppShellProps {
  children: ReactNode;
}

const AppShell = ({ children }: AppShellProps) => {
  return (
    <div className="studio-app-shell">
      <Sidebar />
      <div className="studio-main">{children}</div>
    </div>
  );
};

export default AppShell;
